class MiltonToast extends HTMLElement {
    constructor() {
        super();
        this.errorToast = null;
        this.successToast = null;
    }

    connectedCallback() {
        this.errorToast = this.querySelector("error-toast");
        this.successToast = this.querySelector("success-toast");
    }

    showToast(type, message) {
        const toastElement =
            type === "success" ? this.successToast : this.errorToast;
        const messageElement = toastElement.querySelector(
            type === "success" ? "success-message" : "error-message"
        );

        messageElement.textContent = message;
        this.classList.add("active");
        toastElement.classList.add("active");
        this.animateToast(toastElement);
    }

    animateToast(toastElement) {
        const progressBar = toastElement.querySelector("toast-progress-bar");
        progressBar.style.width = "100%";

        requestAnimationFrame(() => {
            progressBar.style.transition = "width 3s linear";
            progressBar.style.width = "0%";
        });

        setTimeout(() => {
            this.hideToast(toastElement);
        }, 3000);
    }

    hideToast(toastElement) {
        toastElement.classList.remove("active");
        this.classList.remove("active");
        const progressBar = toastElement.querySelector("toast-progress-bar");
        progressBar.style.transition = "";
        progressBar.style.width = "100%";
    }

    showSuccessToast(message) {
        this.showToast("success", message);
    }

    showErrorToast(message) {
        this.showToast("error", message);
    }
}

customElements.define("milton-toast", MiltonToast);

class ModalContainer extends HTMLElement {
    constructor() {
        super();
        this.modal = this.querySelector('modal-viewer');
        this.modalOverlay = this.querySelector('modal-overlay');
        this.modalButton = this.querySelector('modal-button');
        this.modalContent = this.querySelector('modal-content');
        this.allModalClose = this.querySelectorAll('modal-close');

        this.toggleModal = this.toggleModal.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);

        this.modalButton?.addEventListener('click', () => this.toggleModal(true));
        this.allModalClose.forEach(closeBtn => closeBtn?.addEventListener('click', () => this.toggleModal(false)));
        this.modalOverlay?.addEventListener('click', () => this.toggleModal(false));

        window.addEventListener("popstate", this.handleBackButton);
    }

    toggleModal(isOpening = null) {
        const isOpen = this.modal.classList.contains('active');
        const shouldOpen = isOpening ?? !isOpen;

        if (shouldOpen) {
            document.body.classList.add('overflow-hidden');
            this.modal.classList.add('active');
            history.pushState({ modalOpen: true }, "", location.href);
        } else {
            document.body.classList.remove('overflow-hidden');
            this.modal.classList.remove('active');

            // Only manipulate history if the modal was open
            if (history.state?.modalOpen) {
                history.replaceState(null, "", location.href);
            }
        }
    }

    handleBackButton(event) {
        if (this.modal.classList.contains('active')) {
            this.toggleModal(false);
            event.preventDefault();
        }
    }
}

customElements.define('modal-container', ModalContainer);

class ConfirmDialog extends ModalContainer {
    constructor() {
        super();
        this.modalOverlay.replaceWith(this.modalOverlay.cloneNode(true));
        this.confirmButton = this.querySelector('modal-confirm');
        this.cancelButton = this.querySelector('modal-cancel');
        this.confirmButton?.addEventListener('click', () => this.confirmAction());
        this.cancelButton?.addEventListener('click', () => this.cancelAction());
    }

    confirmAction() {
        this.dispatchEvent(new CustomEvent('actionConfirmed'));
        this.toggleModal();
    }

    cancelAction() {
        this.dispatchEvent(new CustomEvent('actionAborted'));
        this.toggleModal();
    }
}

customElements.define('confirm-dialog', ConfirmDialog);


class CopyText extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.notCopiedIcon = this.querySelector("#not-copied");
        this.doneCopiedIcon = this.querySelector("#done-copied");
        this.copyValue = this.dataset.copyValue;
        this.addEventListener("click", (e) => this.copyToClipboard());
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.copyValue).then(() => this.updateUI());
    }

    updateUI() {
        this.toggleIcon("copied");
        document.body.querySelector('milton-toast')?.showSuccessToast(`Discount code copied: ${this.copyValue}`);
    }

    toggleIcon(state) {
        const isCopied = state === "copied";
        this.notCopiedIcon.dataset.active = isCopied ? "false" : "true";
        this.doneCopiedIcon.dataset.active = isCopied ? "true" : "false";

        if (isCopied) {
            setTimeout(() => this.toggleIcon("readyToCopy"), 3000);
        }
    }

}
customElements.define('copy-text', CopyText);